import { Component, ElementRef, NgModule, NgZone, OnInit, ViewChild, ApplicationRef } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { AgmCoreModule, MapsAPILoader } from '@agm/core';
import { } from '@types/googlemaps';
import { Location } from '@angular/common';
import { CustomStorage } from '../providers/Custom-storage.service';
import { Constant } from '../Constant';
import { MouseEvent } from '@agm/core';
import { LanguageService } from '../providers/lang.service';
import { RestApiServices } from '../providers/rest.service';
import { CustomCookieService } from '../providers/mycookie.service';
import { AuthService } from '../auth.service';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from "rxjs/Observable";
import { SharedServiceService } from '../shared/shared-service.service';
import { CartitemsService } from '../providers/cartitems.service';
import { GoogleMapsAPIWrapper, AgmMap, LatLngBounds, LatLngBoundsLiteral} from '@agm/core';
declare var google;

@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.css']
})
export class MapsComponent implements OnInit {

  @ViewChild('gmap') gmapElement: any;
  // map: google.maps.Map;
  map: any;
  enable: boolean = true;
  count: number = 0;
  // lbl_live: string= "";lbl_report: string= "";
  lbl_type: string= "";
  supervisordetailsData: any = [];
  label?: string;
  draggable: boolean;
  checked : boolean=false;
  showDialog: boolean = false;
  zoom: number = 2;
  errorData: any = {};
  bounds:any;
 address: any;
  checintime;txt_lastseen: string="";txt_name: string="";txt_supervisor: string="";
  checout:number=0
  status:String="live";
  // initial center position for the map
  lat: number;
  lng: number;
  previous;  
   geocoder:any;
  markers:any = [];
  currentDate: Date = new Date()
  selectedType: number =0;
  //values = [];
 // selectedType: number = this.values[0];
  values = [
    { id: 1, name: "report"},
    { id: 2, name: "live"}
  ];
  yes: string = "";no: string = "";confirmation: string = "";log_out: string = "";
  
  constructor(private localStorage: CustomStorage, private langService: LanguageService, 
    private restApi: RestApiServices,private cookieService: CustomCookieService, private cartitems : CartitemsService,
    private authService: AuthService, public router: Router, private sharedService: SharedServiceService) {
  }

  ngOnInit() {
    this.sharedService.changeBackbuttonStatus(false);  
    this.langService.getJson().subscribe(data => {
      this.setLabels();
    });
    this.localStorage.getItem(Constant.KEY_SUPERVISORLOGIN).subscribe(result => {
      this.supervisordetailsData = result.response;
      this.checintime =  this.supervisordetailsData.sales_rep_locations.locations_data.check_in_time;
      console.log("checkin"+ this.checintime)
      for (let item of this.supervisordetailsData.sales_rep_locations.locations_data) {
       if(item.check_out_time == 0){
        this.markers.push({
          lat: parseFloat(item.latitude),
          lng: parseFloat(item.longitude),
          checkin:parseFloat(item.check_in_time),
          label: item.sales_rep_id,
          draggable: false
         
        });
      }else{
        this.markers.push({
          lat: parseFloat(item.latitude),
          lng: parseFloat(item.longitude),
          checkout:parseFloat(item.check_out_time),
          label: item.sales_rep_id,
          draggable: false
         
        });
      }
      }
      this.getCoordinates(); 
      let e = this.cookieService.getCookieData("selectedReportMap");     
      if(e){
        this.selectedType =  parseInt(e);
      }
     
    });
  }
  onChange(e) {
    if (e) {
     console.log("clicked is"+e);
     this.restApi.getsupervisorLoginResponseData1(e).subscribe(result => {
     this.cookieService.setCookieData("selectedReportMap", e);
      this.supervisordetailsData = result.response;
      this.markers = []
      for (let item of this.supervisordetailsData.sales_rep_locations.locations_data) {
        if(item.check_out_time == 0){
          this.markers.push({
            lat: parseFloat(item.latitude),
            lng: parseFloat(item.longitude),
            checkin:parseFloat(item.check_in_time),
            label: item.sales_rep_id,
            draggable: false
           
          });
        }else{
          this.markers.push({
            lat: parseFloat(item.latitude),
            lng: parseFloat(item.longitude),
            checkout:parseFloat(item.check_out_time),
            label: item.sales_rep_id,
            draggable: false
          });
        }       
        this.getCoordinates();
   }

   
});
  }
  }

  getCoordinates() {
   // this.markers.setMap(null);
    if (this.markers.length > 0) {
      this.lat= this.markers[0].lat;      
      this.lng= this.markers[0].lng;
      
}
  }
  mapIdle() {
    console.log('idle');
  }
  
  // clickedMarker(label: string, index: number) {
  //   console.log(`clicked the marker: ${label || index}`)

  // }
  onMouseOver(infowindow) {
    
      if (this.previous) {
        this.previous.close();
      }
    
      this.previous = infowindow;
    
      infowindow.open();
    }
  clickedMarker(infowindow) {
    if (this.previous) {
        this.previous.close();
    }
    this.previous = infowindow;
 }
  mapClicked($event: MouseEvent) {
    this.markers.push({
      lat: $event.coords.lat,
      lng: $event.coords.lng,
     // place: $event.coords.place,
      draggable: false
    });
    console.log($event.coords.lat);
    console.log($event.coords.lng);
  }

  // markerDragEnd(m: marker, $event: MouseEvent) {
  //   console.log('dragEnd', m, $event);
  // }
  setLabels() {

    this.langService.getLangLabelValue("LblYes").then(result => {
      this.yes = result;
    });
    this.langService.getLangLabelValue("LblNo").then(result => {
      this.no = result;
    });
    this.langService.getLangLabelValue("LblLogoutMessage").then(result => {
      this.confirmation = result;
    });
    this.langService.getLangLabelValue("LblLogout").then(result => {
      this.log_out = result;
    });
    this.langService.getLangLabelValue("LblLastSeenAt").then(result => {
      this.txt_lastseen = result;
    });
    this.langService.getLangLabelValue("LblName").then(result => {
      this.txt_name = result;
    });
    this.langService.getLangLabelValue("LblSupervisorDetail").then(result => {
      this.txt_supervisor = result;
    });
    // this.langService.getLangLabelValue("LblReport").then(result => {
    //   this.lbl_report = result;
    //  // this.values1.push(this.lbl_report);

    // });
    this.langService.getLangLabelValue("LblReportType").then(result => {
      this.lbl_type = result;
      
     // this.cartitems.mapsstatuses[this.lbl_type] = 0;
    });
    this.langService.getLangLabelValue("LblReport").then(result => {
      
      this.values[0].name =  result
     // this.cartitems.mapsstatuses[this.lbl_report] = 1;
    });
    this.langService.getLangLabelValue("LblLive").then(result => {
      
      this.values[1].name = result;
      //this.cartitems.mapsstatuses[this.lbl_live] = 2;
     console.log("Dfgdfg",result)
    });
   

  }
  logout() {
    
    let languagevalue = this.cookieService.getCookieData(Constant.KEY_CDISELECTEDLANGUAGE);
    this.router.navigate(['/admin', {'region': languagevalue}]);
    }

    callmaps(){
      this.router.navigate(['/mapstest']);
    }
    getdata(){
     
      this.geocoder.geocode(this.markers, (results, status) => {
          if (status == google.maps.GeocoderStatus.OK) {
            let result = results[0];
            let rsltAdrComponent = result.address_components;
            let resultLength = rsltAdrComponent.length;
            if (result != null) {
              this.markers.buildingNum = rsltAdrComponent[resultLength-8].short_name;
              this.markers.streetName = rsltAdrComponent[resultLength-7].short_name;
            } else {
              alert("No address available!");
            }
          }
        });
      }

}




// WEBPACK FOOTER //
// ./src/app/maps/maps.component.ts